module.exports = __webpack_public_path__ + "static/media/close-black.4e89dfbd.svg";